var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.titles[0].num
        ? _c(
            "title-block",
            { attrs: { id: "bm0" } },
            [
              _c("template", { slot: "title" }, [
                _vm._v(_vm._s(_vm.titles[0].label)),
              ]),
              _c(
                "div",
                { staticClass: "mt-10" },
                [
                  _vm._l(_vm.news, function (item, i) {
                    return _c(
                      "div",
                      { key: i, staticClass: "newsCard mb-10" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "h4",
                            staticStyle: { "font-weight": "bold" },
                            attrs: { href: item.uri, target: "about" },
                          },
                          [_vm._v(_vm._s(item.title))]
                        ),
                        _c("div", { staticClass: "message" }, [
                          _c("div", { staticClass: "mr-10" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  rel: "noopener noreferrer",
                                  href: item.uri,
                                  target: "about",
                                },
                              },
                              [_vm._v(_vm._s(item.website))]
                            ),
                          ]),
                          _c("div", { staticClass: "mr-10" }, [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("getTimeDescribe")(item.rtm))
                              ),
                            ]),
                          ]),
                          _c("div", [
                            _c(
                              "a",
                              {
                                staticStyle: { color: "#409EFF" },
                                attrs: {
                                  rel: "noopener noreferrer",
                                  href: item.uri,
                                  target: "about",
                                },
                              },
                              [_vm._v("查看原文")]
                            ),
                          ]),
                        ]),
                        _c("p", {
                          domProps: { innerHTML: _vm._s(item.abstracts) },
                        }),
                      ]
                    )
                  }),
                  _c("pagination", {
                    attrs: { pageNum: _vm.pageNum, total: _vm.total },
                    on: { currentChange: _vm.handleCurrentChange },
                  }),
                ],
                2
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }